import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../../utils/tokens';
import axios from 'axios';
import { filter, forEach } from 'rambda';
import { CategoryCard, CategoryCardGlobal } from '../Categories/CategoryCards';
import { useClientSettingsState } from '../../contexts/client-settings';
import * as R from 'ramda';

const globalListUrl = clientId => `resource/v1/resource-categories/clients/${clientId}?global=true`;
const getImgUrl = id => `/resource/v1/resources/${id}/file/${id}`;

const CategoryOverviewPage = ({ categories }) => {
	let navigate = useNavigate();
	const [globals, setGlobals] = useState([]);
	const [locals, setLocals] = useState([]);
	const clientSettings = useClientSettingsState();

	useEffect(splitCategories, [categories]);

	function splitCategories() {
		// split globals from locals
		const g = filter(c => {
			return c.global === true;
		}, categories);

		const l = filter(c => {
			return c.global === false;
		}, categories);

		// get global top level
		const gTop = filter(c => {
			return !c.parentCategoryId;
		}, g);

		forEach(c => {
			const children = filter(cc => {
				return cc.parentCategoryId === c.id;
			}, g);

			children.sort((a, b) => {
				return a.idx > b.idx ? 1 : -1;
			});

			c.children = children;
		}, gTop);

		const lTop = filter(c => {
			return !c.parentCategoryId;
		}, l);

		forEach(c => {
			const children = filter(cc => {
				return cc.parentCategoryId === c.id;
			}, l);

			children.sort((a, b) => {
				return a.idx > b.idx ? 1 : -1;
			});

			c.children = children;
		}, lTop);

		if (clientSettings.enableUIMindResources) {
			setGlobals(gTop);
		}
		setLocals(lTop);
	}

	function navigateToCat(id, type) {
		navigate(`resources/category/${id}/${type}`)
	}

	function navigateToCourse() {
		navigate('course');
	}


	return (
		<div className="relative px-4 pb-20 sm:px-6 lg:px-8 lg:pt-8 lg:pb-28">
			<h2 className="text-4xl font-bold tracking-tight text-gray-900 pb-12">
				Resources Home
			</h2>
			<div className="relative mx-auto max-w-7xl">
				<div>
					<div className="text-left border-b-2 my-4">
						<h2 onClick={() => navigateToCourse()} className="text-3xl py-2 font-bold tracking-tight text-gray-900 hover:text-purple-900 hover:underline hover:cursor-pointer">
									MIND Course
								</h2>
					</div>
				</div>
				{globals.map(category =>
					category.children.length === 0 ? (
						<div key={category.id}>
							<div className="text-left border-b-2 my-4">
								<h2 onClick={() => navigateToCat(category.id, 'global')} className="text-3xl py-2 font-bold tracking-tight text-gray-900 hover:text-purple-900 hover:underline hover:cursor-pointer">
									{category.title}
								</h2>
							</div>
						</div>
					) : (
						<div key={category.id}>
							<div className="text-left py-2 border-b-2 my-4">
								<h2 onClick={() => navigateToCat(category.id, 'global')} className="text-3xl font-bold tracking-tight text-gray-900  hover:text-purple-900 hover:underline hover:cursor-pointer">
									{category.title}
								</h2>
							</div>
							<div className="mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-4 md:grid-cols-2 2xl:grid-cols-4">
								{category.children.map(childCat => (
									<CategoryCardGlobal key={childCat.id} category={childCat} />
								))}
							</div>
						</div>
					),
				)}

				{locals.map(category =>
					category.children.length === 0 ? (
						<div key={category.id}>
							<div className="text-left border-b-2 my-3">
								<h2 onClick={() => navigateToCat(category.id, 'local')} className="text-3xl py-2 font-bold tracking-tight text-gray-900  hover:text-purple-900 hover:underline hover:cursor-pointer">
									{category.title}
								</h2>
							</div>
						</div>
					) : (
						<>
							<div className="text-left pt-3">
								<h2 onClick={() => navigateToCat(category.id, 'local')} className="text-3xl font-bold tracking-tight text-gray-900  hover:text-purple-900 hover:underline hover:cursor-pointer">
									{category.title}
								</h2>
							</div>
							<div className="mx-auto border-b-2 py-3 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-4 md:grid-cols-2 2xl:grid-cols-4">
								{category.children.map(childCat => (
									<CategoryCard key={childCat.id} category={childCat} />
								))}
							</div>
						</>
					),
				)}
			</div>
		</div>
	);
};

function LoadingCategoryList() {
	return null;
}

const CategoryOverview = () => {
	const [categories, setCategories] = useState([]);
	const [imagesLoaded, setImagesLoaded] = useState(false);

	const currentUser = getUser();

	useEffect(() => {
		const getCategories = async () => {
			return await axios
				.get(globalListUrl(currentUser.clientIdNum))
				.then(response => {
					const filtered = R.filter(c => c.enabled, response.data);
					setCategories(filtered);
				})
				.catch(error => {
					console.log(error);
				});
		};

		getCategories().then();
	}, []);

	useEffect(() => {
		const getCategoryImage = c => {
			return axios({
				method: 'GET',
				url: getImgUrl(c.imageId),
			}).then(
				resp => {
					c.imageUrl = resp.data;
					return resp;
				},
				error => {
					return {};
				},
			);
		};

		const promiseArray = [];
		categories.forEach(c => {
			if (c.imageId) {
				promiseArray.push(getCategoryImage(c));
			}
		});

		Promise.all(promiseArray).then(
			responses => {
				if (responses.length > 0) {
					setImagesLoaded(true);
				}
			},
			error => {
				console.log(error); // zzmatt
			},
		);
	}, [categories]);

	if (!categories) {
		return <LoadingCategoryList />;
	}

	if (!imagesLoaded) {
		return <LoadingCategoryList />;
	}

	if (categories && imagesLoaded) {
		return <CategoryOverviewPage categories={categories} />;
	}
};

export default CategoryOverview;
